import { Box, Grid, Typography, Button } from "@material-ui/core";
import { Localizations } from "../../../Shared/sharedTypes";
import React from "react";
import { Order } from "../../../Shared/GeneratedTypes";
import { Rating } from "@material-ui/lab";

interface propsType {
    submitVideoRating: (value: number) => void;
    submitAudioRating: (value: number) => void;
    submitOverallRating: (value: number) => void;
    provideFeedback: () => void;
    order: Order;
    localizations: Localizations;
}

export default function FinalSurvey({
    order,
    localizations,
    submitVideoRating,
    submitAudioRating,
    submitOverallRating,
    provideFeedback,
}: propsType) {
    return (
        <>
            <Grid
                item
                className="transparentBackground"
                container
                style={{ flex: 1, backgroundColor: "#85C441AA", padding: "24px 24px" }}
            >
                <Box p={2} borderRadius={10} textAlign="center" style={{ backgroundColor: "white", flex: 1 }}>
                    <Typography variant="h6">{localizations.sessionComplete}</Typography>
                    <Box pt={2} pb={2}>
                        <Typography variant="body1">{localizations.thankYouForJoiningUsMessage}</Typography>
                    </Box>
                    {/* <Box pt={2} pb={2}>
                        <Typography variant="body1" style={{ fontWeight: "bold" }}>
                            Total Time
                        </Typography>
                        <Typography variant="body1">
                            {moment(order.clientSessionEnded).diff(moment(order.mentorActiveSince), "minutes")} min
                        </Typography>
                    </Box> */}

                    <Typography variant="body1">{localizations.rateVideo}</Typography>
                    <Rating
                        name="video-rating"
                        value={order?.clientFeedback?.videoRating}
                        onChange={(e, value) => submitVideoRating(value ?? 0)}
                        size="large"
                    />
                    <Typography variant="body1">{localizations.rateAudio}</Typography>
                    <Rating
                        name="audio-rating"
                        value={order?.clientFeedback?.audioRating}
                        onChange={(e, value) => submitAudioRating(value ?? 0)}
                        size="large"
                    />
                    <Typography variant="body1">{localizations.rateOverall}</Typography>
                    <Rating
                        name="overall-rating"
                        value={order?.clientFeedback?.overallRating}
                        onChange={(e, value) => submitOverallRating(value ?? 0)}
                        size="large"
                    />
                    <Box pt={1} pb={1}>
                        <Button
                            variant="contained"
                            onClick={provideFeedback}
                            size="small"
                            color="primary"
                            style={{ marginLeft: 10 }}
                        >
                            {localizations.provideFeedback}
                        </Button>
                    </Box>
                    <Typography variant="body1">{localizations.youCanNowCloseThisWindow}</Typography>
                </Box>
            </Grid>
        </>
    );
}
